import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

export const LocalizationModel = ({ children, title, toggle, setToggle }) => {
  return (
    <Modal
      isOpen={toggle}
      toggle={() => setToggle(!toggle)}
      style={{ maxWidth: '800px', marginTop: '70px' }}
      backdrop="static"
    >
      <ModalHeader toggle={() => setToggle(!toggle)} className="border-bottom">
        <strong>{title}</strong>
      </ModalHeader>
      <ModalBody className="text-center">{children}</ModalBody>
    </Modal>
  );
};
